import React from 'react'
import { useLocation } from "react-router-dom";
import GridDeclaracionSituacionActividad from 'components/pages/ManagementNewForms/DeclaracionSituacionActividad/GridDeclaracionSituacionActividad';
import GridSolicitudVolanteAsistencia from 'components/pages/ManagementNewForms/SolicitudVolanteAsistencia/GridSolicitudVolanteAsistencia';
import { SelectorGastosContingencia } from 'components/pages/ManagementNewForms/SolicitudGastosContingenciaProfesional/SelectorGastosContingencia';
import GridFormularioCertificadoEmpresa from 'components/pages/ManagementNewForms/FormularioCertificadoEmpresa/GridFormularioCertificadoEmpresa';
import GridPagoUnicoCATA from 'components/pages/ManagementNewForms/PagoUnicoCATA/GridPagoUnicoCATA';
import GridReanudacionCATA from 'components/pages/ManagementNewForms/ReanudacionCATA/GridReanudacionCATA';
import GridSolicitudRiesgoEmbarazoLactancia from 'components/pages/ManagementNewForms/RiesgoEmbarazoLactancia/GridSolicitudRiesgoEmbarazoLactancia';
import GridDeclaracionCeseTRADE from 'components/pages/ManagementNewForms/DeclaracionCeseTRADE/GridDeclaracionCeseTRADE';
import GridDeclaracionJuradaCeseActividadDirecta from 'components/pages/ManagementNewForms/DeclaracionJuradaCeseActividadDirecta/GridDeclaracionJuradaCeseActividadDirecta';
import GridDeclaracionJuradaCeseActividadObjetiva from 'components/pages/ManagementNewForms/DeclaracionJuradaCeseActividadObjetiva/GridDeclaracionJuradaCeseActividadObjetiva';
import GridDeclaracionJuradaCeseActividadParcial from 'components/pages/ManagementNewForms/DeclaracionJuradaCeseActividadParcial/GridDeclaracionJuradaCeseActividadParcial';
import GridDeclaracionJuradaGarantiasLaborales from 'components/pages/ManagementNewForms/DeclaracionJuradaGarantiasLaborales/GridDeclaracionJuradaGarantiasLaborales';
import GridDeclaracionJuradaViolenciaGenero from 'components/pages/ManagementNewForms/DeclaracionJuradaViolenciaGenero/GridDeclaracionJuradaViolenciaGenero';
import GridPrestacionModalidadSectorial from 'components/pages/ManagementNewForms/PrestacionModalidadSectorial/GridPrestacionModalidadSectorial';
import GridFormularioPECATA from 'components/pages/ManagementNewForms/FormularioPECATA/GridFormularioPECATA';
import GridPrestacionCUME from 'components/pages/ManagementNewForms/PrestacionCUME/GridPrestacionCUME';
import GridPrestacionModalidadCiclica from 'components/pages/ManagementNewForms/PrestacionModalidadCiclica/GridPrestacionModalidadCiclica';
import GridDeclaracionTrabajadorCuentaPropia from 'components/pages/ManagementNewForms/DeclaracionTrabajadorCuentaPropia/GridDeclaracionTrabajadorCuentaPropia';
import GridModelo145 from 'components/pages/ManagementNewForms/Modelo145/GridModelo145';
import GridSolicitudPagoDirecto from 'components/pages/ManagementNewForms/SolicitudPagoDirecto/GridSolicitudPagoDirecto';
import GridPrestacionEmpleadosHogar from 'components/pages/ManagementNewForms/PrestacionEmpleadosHogar/GridPrestacionEmpleadosHogar';
import GridSolicitudPrestacionesEspeciales from 'components/pages/ManagementNewForms/SolicitudPrestacionesEspeciales/GridSolicitudPrestacionesEspeciales';
import GridSolicitudCATAFuego from 'components/pages/ManagementNewForms/SolicitudCATAFuego/GridSolicitudCATAFuego';
import GridSolicitudGastosFarmacia from 'components/pages/ManagementNewForms/SolicitudGastosFarmacia/GridSolicitudGastosFarmacia';
import GridSolicitudGastosOrtopedia from 'components/pages/ManagementNewForms/SolicitudGastosOrtopedia/GridSolicitudGastosOrtopedia';
import GridSolicitudGastosTransporte from 'components/pages/ManagementNewForms/SolicitudGastosTransporte/GridSolicitudGastosTransporte';
const PageRenderNewForms = () => {
    const location = useLocation();
    const state = location.state || {};
    const query = new URLSearchParams(location.search);

    const idState = state?.id;
    const idQuery = query.get('id');
    const id = Number(idState ?? idQuery ?? NaN);

    const origenState = state?.origen;
    const origenQuery = query.get('origen');
    const origen = Number(origenState ?? origenQuery ?? NaN); // 1 = prestación activa, 2 = general

    const expedienteIdState = state?.expedienteId;
    const expedienteIdQuery = query.get('expedienteId');
    const expedienteId = expedienteIdState ?? (expedienteIdQuery !== null ? Number(expedienteIdQuery) : undefined); // solo para prestaciones activas

    console.log("PageRenderNewForms state:", { id, origen, expedienteId, state });
  
  /*   if (origen === 2) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: '300px' }}>
                <h1>Aquí irá el nuevo componente/página para gestiones generales</h1>
            </div>
        );
    } */

    switch (id) {

        case 1: // Volante_Asistencia
            return (<GridSolicitudVolanteAsistencia expedienteId={expedienteId} origen={origen} />)
        case 2: // Solicitud_Abonos_Gastos_CP
            return (<SelectorGastosContingencia expedienteId={expedienteId} origen={origen} />)
        case 3: // Certificado_Empresa_Regimen_General
            return (<GridFormularioCertificadoEmpresa expedienteId={expedienteId} origen={origen} />)
        case 4: // Declaracion_Situacion_Actividad
            return (<GridDeclaracionSituacionActividad expedienteId={expedienteId} origen={origen} />)
        case 5: // Solicitud_Pago_Directo
            return (<GridSolicitudPagoDirecto expedienteId={expedienteId} origen={origen} />)
        case 6: // Certificado_Empleador_Solicitud_Prestacion_Economica_Empleados_Hogar
            return (<GridPrestacionEmpleadosHogar expedienteId={expedienteId} origen={origen} />)
        case 7: // Solicitud_Reconocimiento_REL
            return (<GridSolicitudRiesgoEmbarazoLactancia expedienteId={expedienteId} origen={origen} />)
        case 8: // Declaracion_Empresarial_Descripcion_Exposicion_REL
            return null
        case 9: // Solicitud_Prestacion_Economica_REL
            //return (<GridPrestacionREL expedienteId={expedienteId} origen={origen} />)
        case 10: // Certificado_Empresa_Datos_Economicos_REL
            return null
        case 11: // Certificado_Empresarial_Solicitud_Prestacion_Economica_REL
            return null
        case 12: // Solicitud_Instrucciones_Prestacion_Economica_Cese_Actividad
            return (<GridFormularioPECATA expedienteId={expedienteId} origen={origen} />)
        case 13: // Solicitud_pago_unico_prestacion_cese_actividad
            return (<GridPagoUnicoCATA expedienteId={expedienteId} origen={origen} />)
        case 14: // Solicitud_reanudacion_prestacion_cese_actividad
            return (<GridReanudacionCATA expedienteId={expedienteId} origen={origen} />)
        case 15: // Declaracion_jurada_cese_actividad_trade
            return (<GridDeclaracionCeseTRADE expedienteId={expedienteId} origen={origen} />)
        case 16: // Declaracion_jurada_cese_definitivo_por_motivos_economicos_tecnicos_y_productivos_Estimacion_directa
            return (<GridDeclaracionJuradaCeseActividadDirecta expedienteId={expedienteId} origen={origen} />)
        case 17: // Declaracion_jurada_cese_definitivo_por_motivos_economicos_tecnicos_y_productivos_Estimacion_objetiva
            return (<GridDeclaracionJuradaCeseActividadObjetiva expedienteId={expedienteId} origen={origen} />)
        case 18: // Declaracion_jurada_cese_parcial_por_motivos_economicos_tecnicos_y_productivos
            return (<GridDeclaracionJuradaCeseActividadParcial expedienteId={expedienteId} origen={origen} />)
        case 19: // Declaracion_jurada_cumplimiento_garantias_laborales
            return (<GridDeclaracionJuradaGarantiasLaborales expedienteId={expedienteId} origen={origen} />)
        case 20: // Declaracion_jurada_fuerza_mayor_y_violencia_genero
            return (<GridDeclaracionJuradaViolenciaGenero expedienteId={expedienteId} origen={origen} />)
        case 21: // Solicitud_prestacion_modalidad_ciclica
            return (<GridPrestacionModalidadCiclica expedienteId={expedienteId} origen={origen} />)
        case 22: // Solicitud_prestacion_modalidad_sectorial
            return (<GridPrestacionModalidadSectorial expedienteId={expedienteId} origen={origen} />)
        case 23: // Solicitud_Prestacion_Economica_CUME
            return (<GridPrestacionCUME expedienteId={expedienteId} origen={origen} />)
        case 24: // Acuerdo_Entre_Progenitores
            return null
        case 25: // Certificado_Empresa_CUME
            return null
        case 26: // Declaracion_Trabajador_Cuenta_Propia
            return (<GridDeclaracionTrabajadorCuentaPropia expedienteId={expedienteId} origen={origen} />)
        case 27: // Declaracion_Medica_Cuidado_Menor
            return null
        case 28: // Solicitud_Comision_Prestaciones_Especiales
            return (<GridSolicitudPrestacionesEspeciales expedienteId={expedienteId} origen={origen} />)
        case 29: // Modelo_145
            return (<GridModelo145 expedienteId={expedienteId} origen={origen} />)
        case 30: // Solicitud_Pago_Directo_Automatico_Autonomos
            return null
        case 31: // AutorizacionColaboradorREDAutonomo
            return null
        case 33: // Solicitud_Pago_Directo_Automatico_Empleados_Hogar
            return (<GridPrestacionEmpleadosHogar expedienteId={expedienteId} origen={origen} />)
        case 34: // Solicitud_CATA_Fuerza_Mayor_Incendios_Forestales
            return (<GridSolicitudCATAFuego expedienteId={expedienteId} origen={origen} />)
        case 35: // Solicitud_Gastos_Farmacia
            return (<GridSolicitudGastosFarmacia expedienteId={expedienteId} origen={origen} />)
        case 36: // Solicitud_Gastos_Ortopedia
            return (<GridSolicitudGastosOrtopedia expedienteId={expedienteId} origen={origen} />)
        case 37: // Solicitud_Gastos_Transporte
            return (<GridSolicitudGastosTransporte expedienteId={expedienteId} origen={origen} />)
        default:
            return null;
    }

}


export default PageRenderNewForms

